import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import PaymentFailed from './PaymentFailed';
import PaymentSuccess from './PaymentSuccess';

const PaymentResult = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const [status, setStatus] = useState<'success' | 'fail' | null>(null);

	const isDevMode = false;

	useEffect(() => {
		const result = searchParams.get('result');

		if (result === 'success' || result === 'fail') {
			setStatus(result);
		} else if (!isDevMode) {
			navigate('/service', { replace: true });
		}
	}, [searchParams, navigate, isDevMode]);

	if (status === 'success') return <PaymentSuccess />;
	if (status === 'fail') return <PaymentFailed />;

	return null;
};

export default PaymentResult;
